import { add as addDuration, Duration, isWithinInterval } from 'date-fns';
import { currentBucketRefetchInterval } from 'app/agriculture/queries/snapshots/config/consts';

/**
 * Returns 1000 * 60 if `now` is within the current bucket interval
 */
export function getSnapshotBucketRefetchInterval(
    timestamp: Date,
    bucketDuration: Duration,
): number | false {
    return isWithinInterval(new Date(), {
        start: timestamp,
        end: addDuration(timestamp, bucketDuration),
    })
        ? currentBucketRefetchInterval
        : false;
}
